export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-1-bedca0ceee399c22c8383bbcb4cbb633.webp";